<template>
    <div class="permission-config">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>角色管理</span>
            </div>

            <!-- 搜索区域 -->
            <div class="search-area">
                <el-input v-model="searchKeyword" placeholder="请输入角色ID或名称搜索" style="width: 300px; margin-right: 10px"
                    clearable @keyup.enter.native="handleSearch">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="resetSearch">重置</el-button>

                <!-- 添加角色按钮 -->
                <el-button type="primary" @click="handleAddRole" style="margin-left: auto">
                    添加角色
                </el-button>
            </div>

            <!-- 角色表格 -->
            <el-table :data="filteredRoleList" style="width: 100%; margin-top: 20px" v-loading="loading" border stripe>
                <el-table-column prop="id" label="角色ID" width="120" align="center">
                </el-table-column>
                <el-table-column prop="name" label="角色名称" align="center">
                </el-table-column>
                <el-table-column prop="description" label="角色描述" align="center">
                </el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleEdit(scope.row)">
                            编辑
                        </el-button>
                        <el-button type="danger" size="mini" @click="handleDelete(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 添加/编辑角色对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="handleDialogClose">
            <el-form ref="roleForm" :model="roleForm" :rules="rules" label-width="100px">
                <el-form-item label="角色ID" prop="id">
                    <el-input v-model="roleForm.id" placeholder="请输入角色ID" :disabled="isEditMode"></el-input>
                </el-form-item>
                <el-form-item label="角色名称" prop="name">
                    <el-input v-model="roleForm.name" placeholder="请输入角色名称"></el-input>
                </el-form-item>
                <el-form-item label="角色描述" prop="description">
                    <el-input v-model="roleForm.description" type="textarea" :rows="3" placeholder="请输入角色描述"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitRoleForm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'PermissionConfig',
    data() {
        return {
            // 角色列表数据
            roleList: [],
            // 搜索关键词
            searchKeyword: '',
            // 加载状态
            loading: false,
            // 对话框显示状态
            dialogVisible: false,
            // 是否为编辑模式
            isEditMode: false,
            // 对话框标题
            dialogTitle: '添加角色',
            // 角色表单数据
            roleForm: {
                id: '',
                name: '',
                description: ''
            },
            // 表单验证规则
            rules: {
                id: [
                    { required: true, message: '请输入角色ID', trigger: 'blur' },
                    { pattern: /^\d+$/, message: '角色ID必须为数字', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        // 过滤后的角色列表
        filteredRoleList() {
            if (!this.searchKeyword.trim()) {
                return this.roleList
            }

            const keyword = this.searchKeyword.toLowerCase()
            return this.roleList.filter(role =>
                (role.id && role.id.toString().toLowerCase().includes(keyword)) ||
                (role.name && role.name.toLowerCase().includes(keyword)) ||
                (role.description && role.description.toLowerCase().includes(keyword))
            )
        }
    },
    created() {
        this.fetchRoleList()
    },
    methods: {
        // API调用：获取角色列表
        async fetchRoleList() {
            this.loading = true
            try {
                const response = await this.$axios.get('/web/roleList/query')
                console.log('获取角色列表响应:', response.data)

                if (response.data.status === 200) {
                    this.roleList = response.data.object || []
                } else {
                    this.$message.error(response.data.msg || '获取角色列表失败')
                }
            } catch (error) {
                console.error('获取角色列表失败:', error)
                this.$message.error('获取角色列表失败')
            } finally {
                this.loading = false
            }
        },

        // API调用：添加角色
        async addRole(data) {
            try {
                // 直接使用后端期望的数据结构
                const requestData = {
                    id: parseInt(data.id), // 确保id是数字类型
                    name: data.name,
                    description: data.description
                }
                console.log('添加角色请求参数:', requestData)

                const response = await this.$axios.post('/web/role/add', requestData)
                console.log('添加角色响应:', response.data)
                return response.data
            } catch (error) {
                console.error('添加角色失败:', error)
                throw error
            }
        },

        // API调用：更新角色
        async updateRole(data) {
            try {
                // 直接使用后端期望的数据结构
                const requestData = {
                    id: parseInt(data.id), // 确保id是数字类型
                    name: data.name,
                    description: data.description
                }
                console.log('更新角色请求参数:', requestData)

                const response = await this.$axios.post('/web/role/update', requestData)
                console.log('更新角色响应:', response.data)
                return response.data
            } catch (error) {
                console.error('更新角色失败:', error)
                throw error
            }
        },

        // API调用：删除角色
        async deleteRole(roleId) {
            try {
                const response = await this.$axios.post('/web/role/delete', null, {
                    params: { roleId }
                })
                console.log('删除角色响应:', response.data)
                return response.data
            } catch (error) {
                console.error('删除角色失败:', error)
                throw error
            }
        },

        // 搜索角色
        handleSearch() {
            // 使用computed属性自动过滤，这里不需要额外处理
        },

        // 重置搜索
        resetSearch() {
            this.searchKeyword = ''
        },

        // 打开添加角色对话框
        handleAddRole() {
            this.isEditMode = false
            this.dialogTitle = '添加角色'
            this.dialogVisible = true
        },

        // 打开编辑角色对话框
        handleEdit(role) {
            this.isEditMode = true
            this.dialogTitle = '编辑角色'
            this.roleForm = {
                id: role.id,
                name: role.name,
                description: role.description || ''
            }
            this.dialogVisible = true
        },

        // 删除角色
        handleDelete(role) {
            this.$confirm(`确定要删除角色 "${role.name}" 吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const response = await this.deleteRole(role.id)
                    if (response.status === 200) {
                        this.$message.success('删除成功')
                        this.fetchRoleList()
                    } else {
                        this.$message.error(response.object || '删除失败')
                    }
                } catch (error) {
                    console.error('删除角色失败:', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => {
                // 用户取消删除
            })
        },

        // 提交角色表单
        submitRoleForm() {
            this.$refs.roleForm.validate(async (valid) => {
                if (valid) {
                    try {
                        if (this.isEditMode) {
                            // 编辑角色
                            const response = await this.updateRole(this.roleForm)
                            if (response.status === 200) {
                                this.$message.success('更新成功')
                                this.dialogVisible = false
                                this.fetchRoleList()
                            } else {
                                this.$message.error(response.object || '更新失败')
                            }
                        } else {
                            // 添加角色
                            const response = await this.addRole(this.roleForm)
                            if (response.status === 200) {
                                this.$message.success('添加成功')
                                this.dialogVisible = false
                                this.fetchRoleList()
                            } else {
                                this.$message.error(response.object || '添加失败')
                            }
                        }
                    } catch (error) {
                        console.error('操作失败:', error)
                        this.$message.error('操作失败')
                    }
                }
            })
        },

        // 对话框关闭处理
        handleDialogClose() {
            this.$refs.roleForm.resetFields()
            this.roleForm = {
                id: '',
                name: '',
                description: ''
            }
        }
    }
}
</script>

<style scoped>
.permission-config {
    padding: 20px;
}

.box-card {
    min-height: calc(100vh - 100px);
}

.search-area {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-table {
    margin-top: 20px;
}

.el-button+.el-button {
    margin-left: 10px;
}
</style>